module.exports = __webpack_public_path__ + "static/img/news4detail1.3adfb6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsMore/news4detail1.jpg
// module id = EltZ
// module chunks = 0